import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import { RootMeta } from 'components/Meta'
import Divider from 'components/Divider'
import AboutSubscribeForm from 'components/forms/AboutSubscribeForm'

const contentWidth = 900
const smallContentWidth = '90%'

const styles = (theme) => ({
  root: {
    width: '100%',
    minHeight: '85vh',
    padding: '45px 25px',
    [theme.breakpoints.down('xs')]: {
      padding: '45px 0',
    },
  },
  subscribeWrapper: {
    width: contentWidth,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: smallContentWidth,
    },
  },
  subscribeCallToAction: {
    padding: '10px 0',
  },
  aboutMessageContainer: {
    width: contentWidth,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: smallContentWidth,
    },
  },
})

const About = ({ classes, data }) => {
  const {
    markdownRemark: page,
    site: { siteMetadata },
  } = data
  return (
    <div className={classes.root}>
      <RootMeta
        title={`About | ${siteMetadata.siteName}`}
        url={siteMetadata.siteUrl}
        description={siteMetadata.siteDescription}
        breadCrumb={[{ url: siteMetadata.siteUrl + '/about', name: 'About' }]}
      />
      <Grid
        spacing={16}
        alignItems="center"
        justify="center"
        classes={{ container: classes.subscribeWrapper }}
        container
      >
        <Grid xs={12} item>
          <Typography
            align="center"
            variant="title"
            style={{ color: '#666', fontWeight: 500 }}
          >
            GET{' '}
            <span
              style={{
                fontFamily: 'Ruthie',
                fontSize: '1.5em',
                textTransform: 'none',
              }}
            >
              updates
            </span>
          </Typography>
          <Typography
            variant="body1"
            align="center"
            classes={{ root: classes.subscribeCallToAction }}
          >
            Become a subscriber today to start receiving newsletters of the
            latest, best trending health content delivered straight to your
            inbox!
          </Typography>
          <AboutSubscribeForm />
        </Grid>
      </Grid>
      <Divider />
      <Grid
        spacing={16}
        justify="center"
        alignItems="center"
        alignContent="center"
        classes={{ container: classes.aboutMessageContainer }}
        container
      >
        <Grid style={{ width: '100%' }} item>
          <Typography
            align="center"
            variant="headline"
            style={{ fontWeight: 300 }}
          >
            ABOUT
          </Typography>
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: page.html }}
          />
        </Grid>
      </Grid>
      <style>{`
        .about-image {
          object-fit: cover;
          float: left;
          width: 100%;
          max-width: 270px;
          height: 100%;
          max-height: 220px;
          margin: 5px 10px 5px 0;
        }
        @media (max-width: 600px) {
          .about-image {
            max-width: 100%;
            float: none;
          }
        }
      `}</style>
    </div>
  )
}

About.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

// prettier-ignore
// eslint-disable-next-line
export const query = graphql`
  query AboutQuery {
    site {
      siteMetadata {
        siteName
        siteUrl
        siteDescription
      }
    }
    markdownRemark(fields: { slug: { regex: "/\/about/" } }) {
      html
      timeToRead
      frontmatter {
        title
      }
    }
  }
`

export default withStyles(styles)(About)



// WEBPACK FOOTER //
// ./src/pages/about.js